module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid11_800x744.62d146e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid11_800x744.jpg
// module id = 3M25
// module chunks = 0